import 'isomorphic-fetch';
import { createAsyncAction, ActionType } from 'typesafe-actions';
import { DataFetchingThunkAction } from '../../types';
import { ClubRegistrationError } from '../types';
import { getErrorCustomData } from '../../../../common/errors/CustomFetchApiError';

export const isFacebookOnlyUserActions = createAsyncAction(
    '@IS_FACEBOOK_USER_ONLY/START',
    '@IS_FACEBOOK_USER_ONLY//SUCCESS',
    '@IS_FACEBOOK_USER_ONLY/FAILED'
)<undefined, boolean, ClubRegistrationError>();

export const apiIsFacebookOnlyUser = (email: string): DataFetchingThunkAction => async (
    dispatch,
    _,
    { apiService, logger }
) => {
    dispatch(isFacebookOnlyUserActions.request());
    try {
        const result = await apiService.shopApi.userIsFacebookOnly(email);
        if (result && result.success && result.data) {
            dispatch(isFacebookOnlyUserActions.success(result.data.isFacebookOnlyUser));
            return;
        }

        throw result;
    } catch (err) {
        logger.error(err, { action: 'apiIsFacebookOnlyUser', ...getErrorCustomData(err) });
        dispatch(isFacebookOnlyUserActions.failure(err));
    }
};

export type IsFacebookOnlyUserActions = ActionType<typeof isFacebookOnlyUserActions>;
